import { Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../shared/services/api.service';
import { DateService } from '../../shared/services/date.service';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'app-bills',
  templateUrl: './bills.component.html',
  styleUrl: './bills.component.scss'
})
export class BillsComponent implements OnInit {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  apiUrl: any;
  countries: any[] = [];

  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      width: 150,
      cellRenderer: (params: any) => {
        const container = document.createElement('div');
        
        const editButton = document.createElement('button');
        editButton.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill', 'me-2');
        editButton.innerHTML = '<i class="bi bi-pencil-fill"></i>';
        editButton.addEventListener('click', () => this.onEdit(params));
        
        const deleteButton = document.createElement('button');
        deleteButton.classList.add('btn', 'btn-sm', 'btn-danger', 'active', 'rounded-pill');
        deleteButton.innerHTML = '<i class="bi bi-trash-fill"></i>';
        deleteButton.addEventListener('click', () => this.onDelete(params));
        
        container.appendChild(editButton);
        container.appendChild(deleteButton);
        
        return container;
      },
    },
    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Country',
      field: 'countryName',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Logo',
      field: 'logo',
      editable: false,
      filter: false,
      cellRenderer: (params: any) => {
        if (params.value) {
          const img = document.createElement('img');
          img.src = params.value;
          img.style.maxWidth = '50px';
          img.style.maxHeight = '30px';
          img.style.objectFit = 'contain';
          return img;
        }
        return null;
      }
    },

    {
      headerName: 'Status',
      field: 'isActive',
      editable: false,
      filter: true,
      cellRenderer: (params: any) => {
        return params.value ? 'Active' : 'Inactive';
      }
    },
    {
      headerName: 'Created At',
      field: 'createdAt',
      editable: false,
      filter: true,
     valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value),
    },
    {
      headerName: 'Updated At',
      field: 'updatedAt',
      editable: false,
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return this._dateService.getFormattedDateWithAMPM(params.value);
        }
        return '';
      }
    },
    
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private _dateService: DateService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    this.getCountries();
  }

  getCountries() {
    const vm = this;
    const type = 'country';
    const apiUrl = '/admin/get-data?type=' + type + '&_limit=500';
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        // Sort countries alphabetically by display name
        vm.countries = res.data.sort((a: any, b: any) => {
          const nameA = a.displayName.toLowerCase();
          const nameB = b.displayName.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      }
    });
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        
        vm.apiUrl = '/bill';
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.data.length;
            params.successCallback(res.data, res.data.length);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  addNew() {
    const vm = this;
    vm.dataObj = { 
      isActive: true,
      bankAccount: {
        bankName: '',
        branchName: '',
        swiftCode: '',
        accountNumber: '',
        remarks: ''
      },
      dynamicFields: [],
      customerFields: []
    };
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'xl' });
  }

  onEdit(data: any) {
    const vm = this;
    vm.zone.run(() => {
      vm.dataObj = { ...data.data };
      // Extract countryId from object to just the ID value
      if (vm.dataObj.countryId && vm.dataObj.countryId._id) {
        vm.dataObj.countryId = vm.dataObj.countryId._id;
      }
      // Ensure bankAccount, dynamicFields, and customerFields are initialized
      if (!vm.dataObj.bankAccount) {
        vm.dataObj.bankAccount = {
          bankName: '',
          branchName: '',
          swiftCode: '',
          accountNumber: '',
          remarks: ''
        };
      }
      if (!vm.dataObj.dynamicFields) {
        vm.dataObj.dynamicFields = [];
      }
      if (!vm.dataObj.customerFields) {
        vm.dataObj.customerFields = [];
      }
      vm.modalRef = vm._modal.open(vm.content, { backdrop: 'static', size: 'xl' });
    });
  }

  onDelete(data: any) {
    const vm = this;
    if (confirm('Are you sure you want to delete this bill?')) {
      vm._api.deleteData('/bill/' + data.data._id).subscribe((res: any) => {
        if (res && !res.error) {
          vm.refreshGrid();
        }
      });
    }
  }

  addDynamicField() {
    if (!this.dataObj.dynamicFields) {
      this.dataObj.dynamicFields = [];
    }
    this.dataObj.dynamicFields.push({
      label: '',
      value: '',
      type: 'text',
      isRequired: false
    });
  }

  removeDynamicField(index: number) {
    if (this.dataObj.dynamicFields && this.dataObj.dynamicFields.length > 0) {
      this.dataObj.dynamicFields.splice(index, 1);
    }
  }

  addCustomerField() {
    if (!this.dataObj.customerFields) {
      this.dataObj.customerFields = [];
    }
    this.dataObj.customerFields.push({
      fieldName: '',
      label: '',
      type: 'text',
      isRequired: true,
      validationRegex: '',
      validationMessage: '',
      placeholder: '',
      displayOrder: this.dataObj.customerFields.length + 1
    });
  }

  removeCustomerField(index: number) {
    if (this.dataObj.customerFields && this.dataObj.customerFields.length > 0) {
      this.dataObj.customerFields.splice(index, 1);
      // Update display order for remaining fields
      this.dataObj.customerFields.forEach((field: any, i: number) => {
        field.displayOrder = i + 1;
      });
    }
  }

  @ViewChild('content') content!: TemplateRef<any>;

  errorMessage: string = '';

  onSubmit(flag: any) {
    this.errorMessage = '';
    const apiUrl = this.dataObj._id ? '/bill/' + this.dataObj._id : '/bill';
    const method = this.dataObj._id ? 'putData' : 'postData';
    
    this._api[method](apiUrl, this.dataObj).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          this.onClose();
          this.dataObj = {};
          if (this.gridApi) {
            this.refreshGrid();
          }
        } else {
          this.errorMessage = res.message || 'Failed to save biller';
        }
      },
      error: (err: any) => {
        this.errorMessage = (err.error && err.error.message) || err.message || 'Failed to save biller';
      }
    });
  }

  onClose() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.dataObj = {};
    this.errorMessage = '';
  }

}
